import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../mypage/Terms.css';
import iconBack from '../../assets/images/icon-back.svg';

const PublicPrivacy: React.FC = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/login');
  };

  return (
    <div className="terms-container">
      <div className="terms-header">
        <div className="terms-header-wrapper">
          <img src={iconBack} alt="뒤로가기" className="header-icon" onClick={handleBack} />
          <h1 className="terms-title">개인정보처리방침</h1>
          <div className="header-icon"></div>
        </div>
      </div>

      <div className="terms-content">
        <section className="terms-section">
          <h2 className="terms-section-title">제1조 (개인정보의 처리 목적)</h2>
          <p className="terms-text">
            삐삐(이하 "회사")는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보 보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
          </p>
          <p className="terms-text">
            1. 회원 가입 및 관리: 회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 각종 고지·통지 등
          </p>
          <p className="terms-text">
            2. 서비스 제공: 통신 서비스 가격 비교, 맞춤형 요금제 추천, 상담 서비스 제공 등
          </p>
          <p className="terms-text">
            3. 마케팅 및 광고에 활용: 이벤트 및 광고성 정보 제공, 서비스의 유효성 확인 등
          </p>
        </section>

        <section className="terms-section">
          <h2 className="terms-section-title">제2조 (개인정보의 처리 및 보유기간)</h2>
          <p className="terms-text">
            1. 회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.
          </p>
          <p className="terms-text">
            2. 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다:
            <br />- 회원 가입 및 관리: 회원 탈퇴 시까지
            <br />- 서비스 제공: 서비스 공급 완료 및 요금 결제·정산 완료 시까지
          </p>
        </section>

        <section className="terms-section">
          <h2 className="terms-section-title">제3조 (처리하는 개인정보 항목)</h2>
          <p className="terms-text">
            회사는 다음의 개인정보 항목을 처리하고 있습니다:
          </p>
          <p className="terms-text">
            1. 필수항목: 이름, 휴대전화번호, 생년월일, 성별, 통신사
          </p>
          <p className="terms-text">
            2. 선택항목: 이메일, 주소, 은행계좌정보
          </p>
          <p className="terms-text">
            3. 서비스 이용 과정에서 자동으로 생성되어 수집되는 정보: 접속 IP, 쿠키, 서비스 이용기록, 접속로그 등
          </p>
        </section>

        <section className="terms-section">
          <h2 className="terms-section-title">제4조 (개인정보의 제3자 제공)</h2>
          <p className="terms-text">
            회사는 정보주체의 개인정보를 제1조(개인정보의 처리 목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.
          </p>
        </section>

        <section className="terms-section">
          <h2 className="terms-section-title">제5조 (개인정보의 파기)</h2>
          <p className="terms-text">
            1. 회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.
          </p>
          <p className="terms-text">
            2. 개인정보 파기의 절차 및 방법은 다음과 같습니다:
            <br />- 파기절차: 불필요한 개인정보는 개인정보의 처리가 불필요한 것으로 인정되는 날로부터 5일 이내에 해당 개인정보를 파기합니다.
            <br />- 파기방법: 전자적 파일 형태로 기록·저장된 개인정보는 기록을 재생할 수 없도록 파기합니다.
          </p>
        </section>

        <section className="terms-section">
          <h2 className="terms-section-title">제6조 (정보주체의 권리·의무 및 행사방법)</h2>
          <p className="terms-text">
            정보주체는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다:
          </p>
          <p className="terms-text">
            1. 개인정보 열람 요구
          </p>
          <p className="terms-text">
            2. 오류 등이 있을 경우 정정 요구
          </p>
          <p className="terms-text">
            3. 삭제 요구
          </p>
          <p className="terms-text">
            4. 처리정지 요구
          </p>
        </section>

        <section className="terms-section">
          <h2 className="terms-section-title">제7조 (개인정보 보호책임자)</h2>
          <p className="terms-text">
            회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
          </p>
          <p className="terms-text">
            - 개인정보 보호책임자: 강석호
            <br />- 연락처: 1877-1847, official@bbibbi.co.kr
          </p>
        </section>

        <section className="terms-section">
          <h2 className="terms-section-title">제8조 (개인정보의 안전성 확보조치)</h2>
          <p className="terms-text">
            회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다:
          </p>
          <p className="terms-text">
            1. 관리적 조치: 내부관리계획 수립·시행, 정기적 직원 교육 등
          </p>
          <p className="terms-text">
            2. 기술적 조치: 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 개인정보의 암호화, 보안프로그램 설치
          </p>
          <p className="terms-text">
            3. 물리적 조치: 전산실, 자료보관실 등의 접근통제
          </p>
        </section>

        <div className="terms-footer">
          <p>시행일: 2024년 1월 1일</p>
        </div>
      </div>
    </div>
  );
};

export default PublicPrivacy;
